import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ICreateUpdateStudyUnitPayload } from 'src/app/Services/content-management/content-management.service';

@Component({
  selector: 'app-relocate-topic-content',
  templateUrl: './relocate-topic-content.component.html',
  styleUrls: ['./relocate-topic-content.component.css'],
})
export class RelocateTopicContentComponent implements OnInit {
  @Input() SubjectParentInput: any;
  @Input() Refresh: any;
  @Input() MajorTopic: any;
  @Input() subjectParentEnable: boolean;
  @Input() StudyUnit: ICreateUpdateStudyUnitPayload;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    
  ) {}

  ngOnInit(): void {
  }
  onSave() {}
  onCross() {
    this.activeModal.close(false);
  }
  closeAddEditElement(event: any) {
    this.onCross();
  }
  onCancel(event: any) {
    this.onCross();
  }
}
